import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
//utils
import { safeGet } from '../../../../../utils';
//style
import './AccountSection.css';

const AccountSection = (props) => {
  var accountId;
  if (props.type === "master") {
    accountId = safeGet(props.sweepInstruction, "sweepParticipantsAccounts.masterAccount");
  } else if (props.type === "sub") {
    accountId = safeGet(props.sweepInstruction, "sweepParticipantsAccounts.subAccount");
  }

  const currentAccount = props.accounts.find(account => account.id === accountId);

  var accountSectionJsx = "";
  if (props.listType === "sow-sweep") {
    const accountDetails = (Array.isArray(props.accounts) && props.accounts.find(acc => props.sweepInstruction && props.sweepInstruction[props.type + "Account"] && (props.sweepInstruction[props.type + "Account"]["id"] === acc.id))) || {}
    accountSectionJsx = (
      <div className={classnames('sub-account-details', props.bsClass)}>
        <h6 className="sub-account-details__header">{props.type === "master" ? "Master" : "Sub"}</h6>
        <p className="sub-account-details__account-name">
          {`${safeGet(accountDetails, "accountNumber")}
                ${safeGet(accountDetails, "accountNumber", undefined) ? ',' : ''}
                ${safeGet(accountDetails, "bic")}
                ${safeGet(accountDetails, "bic", undefined) ? ',' : ''}
                ${safeGet(accountDetails, "country.name")}
                ${safeGet(accountDetails, "country.name", undefined) ? ',' : ''}
                ${safeGet(accountDetails, "currency.name")}`}
        </p>
        <p className="sub-account-details__others">
          {safeGet(accountDetails, "entityName")}
        </p>
      </div>
    )
    return accountSectionJsx
  }
  if (props.type === "master") {
    var masterAccountDetailsCss = classnames('master-account-details', props.bsClass);
    if (currentAccount) {
      if (currentAccount.accountHolder !== undefined && currentAccount.bankName === undefined) {
        accountSectionJsx = (
          <div className={masterAccountDetailsCss}>
            <label className="master-account-details__header">{props.master || 'Master'}</label>
            <p className="master-account-details__account-name">
              {`${safeGet(currentAccount, "accountType.name")}
                ${safeGet(currentAccount, "accountType.name", undefined) ? ',' : ''}
                ${safeGet(currentAccount, "country.name")}
                ${safeGet(currentAccount, "country.name", undefined) ? ',' : ''}
                ${safeGet(currentAccount, "currency.name")}`}
            </p>
            <p className="master-account-details__others">
              {safeGet(currentAccount, "accountHolder.name")}
            </p>
            <p className="master-account-details__others">
              {safeGet(currentAccount, "accountTitle") !== "" ? (safeGet(currentAccount, "accountTitle")) : ''}
            </p>
            <p className="master-account-details__others">
              {safeGet(currentAccount, "tempRefrenceId") !== "" ? (safeGet(currentAccount, "tempRefrenceId")) : ''}
            </p>
          </div>
        );
      } else {
        accountSectionJsx = (
          <div className={masterAccountDetailsCss}>
            <label className="master-account-details__header">{props.master || 'Master'}</label>
            <p className="master-account-details__account-name">
              {`${safeGet(currentAccount, "accountNumber")},
                ${safeGet(currentAccount, "branchCode")},
                ${safeGet(currentAccount, "country.name")},
                ${safeGet(currentAccount, "currency.name")}`}
            </p>

            <p className="master-account-details__others">
              {safeGet(currentAccount, "accountHolder.name")}
            </p>
            <p className="master-account-details__others">
              {safeGet(currentAccount, "bankName")}
            </p>
          </div>
        )
      }
    } else {
      accountSectionJsx = (
        <div className={masterAccountDetailsCss}>
          <label className="master-account-details__header">{props.master || 'Master'}</label>
        </div>
      )
    }
  } else if (props.type === "sub") {
    var subAccountDetailsCss = classnames('sub-account-details', props.bsClass);
    if (currentAccount) {
      if (currentAccount.accountHolder !== undefined && currentAccount.bankName === undefined) {
        accountSectionJsx = (
          <div className={subAccountDetailsCss}>
            <label className="sub-account-details__header">{props.sub || 'Sub'}</label>
            <p className="sub-account-details__account-name">
              {`${safeGet(currentAccount, "accountType.name")}
                ${safeGet(currentAccount, "accountType.name", undefined) ? ',' : ''}
                ${safeGet(currentAccount, "country.name")}
                ${safeGet(currentAccount, "country.name", undefined) ? ',' : ''}
                ${safeGet(currentAccount, "currency.name")}`}
            </p>
            <p className="sub-account-details__others">
              {safeGet(currentAccount, "accountHolder.name")}
            </p>
            <p className="sub-account-details__others">
              {safeGet(currentAccount, "accountTitle") !== "" ? (safeGet(currentAccount, "accountTitle")) : ''}
            </p>
            <p className="master-account-details__others">
              {safeGet(currentAccount, "tempRefrenceId") !== "" ? (safeGet(currentAccount, "tempRefrenceId")) : ''}
            </p>
          </div>
        );
      } else {
        accountSectionJsx = (
          <div className={subAccountDetailsCss}>
            <label className="sub-account-details__header">{props.sub || 'Sub'}</label>
            <p className="sub-account-details__account-name">
              {`${safeGet(currentAccount, "accountNumber")}, ${safeGet(currentAccount, "branchCode")}, ${safeGet(currentAccount, "country.name")}, ${safeGet(currentAccount, "currency.name")}`}
            </p>
            <p className="sub-account-details__others">
              {safeGet(currentAccount, "accountHolder.name")}
            </p>
            <p className="sub-account-details__others">
              {safeGet(currentAccount, "bankName")}
            </p>
          </div>
        )
      }
    } else {
      accountSectionJsx = (
        <div className={subAccountDetailsCss}>
          <label className="sub-account-details__header">{props.sub || 'Sub'}</label>
        </div>
      )
    }
  }
  return accountSectionJsx;
}

AccountSection.defaultProps = {
  type: 'master'
}

AccountSection.propTypes = {
  type: PropTypes.string,
  sweepInstruction: PropTypes.object.isRequired,
  accounts: PropTypes.arrayOf(PropTypes.object).isRequired,
  bsClass: PropTypes.string
}

export default AccountSection;



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsCashCon/AccountSection/AccountSection.js